import { Action, createReducer, on } from "@ngrx/store";
import * as warehousesActions from './warehouses.actions';
import { IPagination } from "src/app/shared/models/page.model";
import { IWarehouse } from "../models/warehouses.models";


export interface WarehousesState {
  allWarehouses: IWarehouse[],
  metadata: IPagination | null;
  warehouses: IWarehouse[],
  warehouse: IWarehouse | null,
  loading: boolean,
  saving: boolean,
  keyword: string
}

export const initialBrandsState: WarehousesState = {
  allWarehouses: [],
  metadata: null,
  warehouses: [],
  warehouse: null,
  loading: false,
  saving: false,
  keyword: ''
}

const featureReducer = createReducer(
  initialBrandsState,
  on(
    warehousesActions.FetchAllWarehousesSuccess,
    (state, action) => ({
      ...state,
      warehouses: action.warehouses.data,
      metadata: action.warehouses.metadata,
    })
  ),
  on(
    warehousesActions.LoadMoreWarehousesSuccess,
    (state, action) => ({
      ...state,
      warehouses: [...state.warehouses, ...action.warehouses.data],
      metadata: action.warehouses.metadata,
    })
  ),
  on(
    warehousesActions.AddWarehouseSuccess,
    (state, action) => {
      const newWarehouses = state.warehouses.map((warehouse) =>
        warehouse.id === action.warehouse.id ? action.warehouse : {
          ...warehouse,
          is_primary: action.warehouse.is_primary ? false : action.warehouse.is_primary,
        }
      );
      if(state.metadata?.count === newWarehouses.length) {
        return {
          ...state,
          warehouses: [...newWarehouses, action.warehouse],
          metadata: {
            ...state.metadata as IPagination,
            count: (state.metadata?.count || 0) + 1,
          },
        }
      }
      return {
        ...state,
        warehouses: [...newWarehouses],
        metadata: {
          ...state.metadata as IPagination,
          count: (state.metadata?.count || 0) + 1,
        },
      }
    }
  ),
  on(warehousesActions.UpdateWarehouseSuccess, (state, action) => ({
    ...state,
    warehouses: state.warehouses.map((warehouse) =>
      warehouse.id === action.warehouse.id ? action.warehouse : {
        ...warehouse,
        is_primary: action.warehouse.is_primary ? false : action.warehouse.is_primary,
      }
    ),
    warehouse: action.warehouse,
  })),
  on(warehousesActions.DeleteWarehouseSuccess, (state, action) => ({
    ...state,
    warehouses: [
      ...state.warehouses.filter(
        (warehouse) =>
          warehouse.id !== action.id
      ),
    ],
  })),
  on(warehousesActions.SetWarehousesLoader, (state, action) => ({
    ...state,
    loading: action.isLoading
  })),
  on(warehousesActions.SetWarehousesSavingLoader, (state, action) => ({
    ...state,
    saving: action.isSaving
  })),
)


export function warehousesReducer(state: WarehousesState | undefined, action: Action) {
  return featureReducer(state, action);
}
